import { DateTime } from 'luxon';
import { makeAutoObservable } from 'mobx';
import { LoanAccountsApiResponse } from '../../api/GroupApi';

type LoanOrg = {
  id: number,
  accountCode: string,
  ncExternalId?: string,
  isLender: boolean,
};

export class LoanAccount {
  id: number = null;
  created: DateTime = null;
  org1: LoanOrg = {
    id: null,
    accountCode: '',
    isLender: false,
  };
  org2: LoanOrg = {
    id: null,
    accountCode: '',
    isLender: false,
  };
  name: string = '';
  isRecharger: boolean = false;
  isBrag: boolean = false;

  constructor() {
    makeAutoObservable(this);
  }

  static fromApi(apiData: LoanAccountsApiResponse): LoanAccount {
    const intercompanyLoan = new LoanAccount();
    
    intercompanyLoan.id = apiData.id;
    intercompanyLoan.created = apiData.created;
    intercompanyLoan.org1 = apiData.org1;
    intercompanyLoan.org2 = apiData.org2;
    intercompanyLoan.name = apiData.name;
    intercompanyLoan.isRecharger = apiData.isRecharger;
    intercompanyLoan.isBrag = apiData.isBrag;

    return intercompanyLoan;
  }
}